export default "__VITE_ASSET__CDAb4i9g__"